import moment from 'moment-timezone';

export const convertToUtc = (dateString: string): string => {
  if (!dateString) {
        throw new Error("date string is required.");
    }
  const [year, month, day] = dateString.split("-").map(Number);
  const local = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T00:01:00`;

  // Parse as NY time
  const m = moment.tz(local, 'America/New_York');
  const utc = m.utc().format(); // ISO string in UTC

  return utc;
}

